import { useRef, useEffect, useState } from "react";
import { useAppContext } from "../../libs/AppContext";
import ParcelsTable from "../table/groups/ParcelsTable";
import AddParcelForm from "../modals/groups/AddParcelForm";
import Modal from "../common/Modal";
import UploadParcelPictures from "../modals/groups/UploadParcelPictures";

const ParcelsLayout = ({
  currentPage,
  onNextPage,
  perPage,
  onPrevPage,
  handlePerPage,
  handlePageClick,
  showAddForm,
}) => {
  const [showUploadPicturesModal, setShowUploadPicturesModal] = useState(false);
  const { setVisibleTableColumns } = useAppContext();
  const columnRef = useRef({
    "Tracking Number": true,
    "Room Number": true,
    "Total weight": true,
    CBM: true,
    "E.A.I.₾": true,
  });

  useEffect(() => {
    setVisibleTableColumns(columnRef.current);
  }, [setVisibleTableColumns]);

  const handleShowUploadPicturesModal = () => {
    setShowUploadPicturesModal(!showUploadPicturesModal);
  };

  return (
    <>
      <div
        className={`${
          showAddForm ? "h-auto" : "h-0 overflow-hidden"
        } transition-all duration-300`}
      >
        <AddParcelForm handleShowModal={handleShowUploadPicturesModal} />
      </div>
      <Modal
        showmodal={showUploadPicturesModal}
        setShowModal={setShowUploadPicturesModal}
      >
        <UploadParcelPictures handleShowModal={handleShowUploadPicturesModal} />
      </Modal>
      <ParcelsTable
        currentPage={currentPage}
        onNextPage={onNextPage}
        perPage={perPage}
        onPrevPage={onPrevPage}
        handlePerPage={handlePerPage}
        handlePageClick={handlePageClick}
      />
    </>
  );
};

export default ParcelsLayout;
